import { startOfDay } from './startOfDay';

export const isDateWithinDatePickerBounds = (date: Date, minDate: Date, maxDate: Date): boolean => {
  const day = startOfDay(date).getTime();
  return day >= startOfDay(minDate).getTime() && day <= startOfDay(maxDate).getTime();
};
